import React, { useState } from 'react';
import { Button, Pagination, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { CONSTANT } from '../../../../config/Constant';
import { CloudDownloadOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import DeleteForm from './DeleteForm';
// import { AppDispatch } from '../../../../store/app';
// import { useDispatch } from 'react-redux';
// import { statusAsteriskNumber } from '../../../../store/NumberManagementSlice';
import { PaginationProps } from 'antd/lib/pagination';
import SendAsteriskViewStatus from './SendAsteriskViewStatus';
// import DeleteForm from './DeleteForm';

interface DataType {
  key: string;
  id: string | any;
  asterisk_number: string | any;
  shadow_number: string | any;
  name: string | any;
  active: boolean;
  file: string | any;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  // const dispatch: AppDispatch = useDispatch();

  const {
    listData,
    setListData,
    tableloading,
    getList,
    totalData,
    setTableLoading,
    paginationData,
    setPaginationData,
  } = props;

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const [openViewStatusDrawer, setOpenViewStatusDrawer] = useState<boolean>(false);
  const [openViewStatusData, setOpenViewStatusData] = useState<any>();

  // const userDetails = localStorage.getItem('userDetails');
  // const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    id: item?.index ?? index + 1,
    asterisk_number: item?.asterisk_number,
    shadow_number: item?.shadow_number,
    name: item?.name,
    active: item?.active,
    file: item?.file_download_link, // Adjust this based on your actual data
    _id: item?._id,
    created_date: item?.created_date,
  }));

  // const handleBlockUser = (record: any, val: boolean) => {
  //   const payload = {
  //     username: record?.username,
  //     active: val,
  //   };
  //   dispatch(statusAsteriskNumber(payload))
  //     .then((res: any) => {
  //       // handleEditModal();
  //       getList();
  //     })
  //     .catch((error: any) => {
  //       console.log('error', error);
  //     });
  // };

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = () => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const handleChange: PaginationProps['onChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      // fixed: 'left',
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },

    {
      title: 'Asterisk Number',
      dataIndex: 'asterisk_number',
      key: 'asterisk_number',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.asterisk_number || '').localeCompare(b.asterisk_number || ''),
      render: (_, record) => {
        return record?.asterisk_number ? record?.asterisk_number : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Shadow Number',
      dataIndex: 'shadow_number',
      key: 'shadow_number',
      width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.shadow_number || '').localeCompare(b.shadow_number || ''),
      render: (_, record) => {
        return record?.shadow_number ? record?.shadow_number : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 180,
      //
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
      render: (_, record) => {
        return record?.name ? record?.name : CONSTANT.NO_DATA_FOUND;
      },
    },

    // {
    //   title: 'Status',
    //   key: 'active',
    //   dataIndex: 'active',
    //   width: 120,
    //   sortDirections: ['descend', 'ascend'],
    //   sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
    //   render: (_, record, index) => {
    //     return (
    //       <Switch
    //         defaultValue={record?.active === false ? false : true}
    //         onChange={(e: boolean) => {
    //           handleBlockUser(record, e);
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      // fixed: 'right',
      // hidden: !checkPrivileges(userRoles, 'admin'),
      render: (_, record) => (
        <Space
          size="middle"
          wrap
        >
          <Tooltip title={'View Status'}>
            <Button
              onClick={() => {
                handleViewStatus(record);
              }}
              icon={<EyeOutlined />}
              type="default"
              target="_blank"
              className="iconBtn"
            />
          </Tooltip>
          <Tooltip title={'Download File'}>
            <Button
              href={record.file}
              icon={<CloudDownloadOutlined />}
              type="default"
              target="_blank"
              className="iconBtn"
            />
          </Tooltip>
          <Tooltip title={'Delete Number'}>
            <Button
              onClick={() => {
                handleDeleteRequest(record);
              }}
              icon={<DeleteOutlined />}
              type="default"
              className="cancelBtn iconBtn"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleViewStatus = (record: any) => {
    setOpenViewStatusDrawer(!openViewStatusDrawer);
    setOpenViewStatusData(record);
  };
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={'fixed'}
        />
      </div>
      <div className="text-center mt-20 mb-30">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current ?? 1}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          // showSizeChanger
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>

      <DeleteForm
        title={openDeleteData?.name}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?._id}
        name={'Number'}
        number={openDeleteData?.asterisk_number}
        getList={getList}
      />
      <SendAsteriskViewStatus
        handleViewStatus={handleViewStatus}
        openViewStatusDrawer={openViewStatusDrawer}
        openViewStatusData={openViewStatusData}
      />
    </>
  );
};
export default ListTable;
